/**
 * Import all front-end JS scripts.
 * 
 * Compiles to assets/scripts/theme-scripts.js
 */

 /* eslint-disable no-unused-vars */

 // Import ES6 modules (recommended)
 // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
 import './base/main-navigation';
 import './base/sticky-sidebar';
 import './base/accordion';
 import './base/edge-detection.js';
 import './base/search-open.js';
 import './base/mobile-menu-open.js';
 
 // Import JS from blocks
import '../../../blocks/hero-slideshow/hero-slideshow.js';
import '../../../blocks/image-slider/image-slider.js';
import '../../../blocks/side-by-side/side-by-side.js';

// Or import entire JS files the "old school" way
